import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
    import { IconName, Icon, Typo } from '@travelata-libs/ui-kit';
    import { ConfirmationType } from '../lib/types';
    import getConfirmationTypeAdditionals from '../lib/getConfirmationTypeAdditionals';

    interface ConfirmationTypeTooltip {
        type?: ConfirmationType;
        color?: 'white' | 'black',
        productType?: string,
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmationTypeAdditionals',
  props: {
    type: { default: undefined },
    color: { default: 'white' },
    productType: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { type: ConfirmationType, color: 'white' | 'black', productType: string };

    

    const additionals = computed(() => getConfirmationTypeAdditionals(props.type, props.productType));


return { __sfc: true,props, additionals, Icon, Typo }
}

})